export default __webpack_public_path__ + "static/media/error.ea04ddbd.gif";